import dayjs from 'dayjs';
import { ITask } from "./types";

const setupTasks = (newTasks: ITask[]) => newTasks.map(({callback, delay}) => setInterval(callback, delay));

const finishTasks = (intervalIds: number[]) => intervalIds.forEach(intervalId => clearInterval(intervalId));

const substractXMinsFromNow = (minutes: number) => {
  return dayjs()
    .subtract(minutes, 'minutes')
    .format('YYYY-MM-DDTHH:mm');
}

const substractXMinsFromDate = (date: Date | string, minutes: number) => {
  return dayjs(date)
    .subtract(minutes, 'minutes').utc()
    .format('YYYY-MM-DDTHH:mm');
}

const tasks = {
  setupTasks,
  finishTasks,
  substractXMinsFromNow,
  substractXMinsFromDate
};

export default tasks;
